// extracted by mini-css-extract-plugin
export default {"ChartPage__fields":"RegRequestsTable_ChartPage__fields__PbmT7","tourButton":"RegRequestsTable_tourButton__lmAYy"};